<template>
    <div class="vh-100">

        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left" @click="back">
                    <div class="header-item">
                        <img src="../../assets/gambar/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Tambah Layanan Self Service</div>
                <div class="header-top--right">
                    <div class="header-item">
                        <!-- <img src="../../assets/icons/search.svg" alt=""> -->
                    </div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <div class="content-wrapper main-page flex-100">

            <div class="w-limit p-t-16 p-d-20 p-x-20">
                <div class="form-group mod">
                    <label for="namalayanan" class="form-label require">Nama Layanan</label>
                    <input type="text" class="form-control inputs" placeholder="Nama Layanan..." id="namalayanan"
                           v-model="snap_nama" v-on:keyup="inputnama">
                    <ErrorMessage class="error" label="Nama Layanan" ref="errmsg_nama_layanan"
                                  :validation="$v.snap_nama"></ErrorMessage>
                </div>

                <div class="m-t-16 hide">
                    <label for="radio1" class="form-label require">Jenis Layanan</label>
                    <div class="radio-group">
                        <div class="radio-wrapper">
                            <div class="radio-item" @click="Selfserviceactive">
                                <input type="radio" id="radio1" name="radioboxx" v-model="Jenis_layanan">
                                <label for="radio1">Self Service</label>
                            </div>
                            <div class="radio-item" @click="DropOffactive">
                                <input type="radio" id="radio2" name="radioboxx" v-model="Jenis_layanan">
                                <label for="radio2">Drop Off</label>
                            </div>
                        </div>
                    </div>
                    <ErrorMessage class="error" label="Jenis Layanan" ref="errmsg_jenis_layanan"
                                  :validation="$v.Jenis_layanan"></ErrorMessage>
                </div>


                <div class="m-t-16 d-flex">
                    <div class="flex-1">
                        <label for="form1" class="form-label require">Harga</label>
                        <!--<div class="input-group mod">-->
                        <!--    <div class="input-group-prepend">-->
                        <!--        <span class="input-group-text">Rp</span>-->
                        <!--    </div>-->
                        <!--    <input type="tel" class="form-control" placeholder="123.456"  v-model="snap_harga" v-on:keyup="inputnumber">-->
                        <!--</div>-->
                        <InputRupiah
                                :outerDivClass="'input-group mod'"
                                :innerDivClass="'input-group-prepend'"
                                v-model="snap_harga"
                                :showRp="true"
                                :placeholder="14000"
                                :comma="false"
                                ref="inputrupiah"
                        />
                        <ErrorMessage class="error" label="Harga" ref="errmsg_harga"
                                      :validation="$v.snap_harga.raw"></ErrorMessage>
                    </div>

                    <div class="m-l-8">
                        <div class="form-group mod">
                            <label for="exampleFormControlSelect1" class="form-label">Per</label>
                            <select class="form-control right-icon icon-dropdown" id="exampleFormControlSelect1"
                                    v-if="Jenis_layanan==='1'" disabled>
                                <option>Load</option>
                            </select>
                            <select class="form-control right-icon icon-dropdown" id="exampleFormControlSelect1" v-else
                                    v-model="selected_satuan_snap" v-on:change="validateortoleransi" disabled>
                                <option value="" selected>Pilih Satuan</option>
                                <option v-for="optionsnap in selected_satuan"
                                        v-bind:value="{value:optionsnap.value, text: optionsnap.text}">
                                    {{ optionsnap.text }}
                                </option>
                            </select>
                        </div>
                        <ErrorMessage v-if="Jenis_layanan.toString() === '2'" ref="errmsg_satuan" class="error"
                                      label="Satuan" :validation="$v.selected_satuan_snap.text"></ErrorMessage>
                    </div>
                </div>
            </div>

            <div class="separator-line"></div>

            <div class="w-limit p-y-20 p-x-20">
                <div class="form-group mod">
                    <label for="form2" class="form-label require">Jenis mesin yang digunakan</label>
                    <select class="form-control right-icon icon-dropdown" id="form2" v-if="Jenis_layanan==='1'"
                            v-model="Jenis_mesin" v-on:change="validateortoleransi">
                        <option value="" selected>Pilih Jenis Mesin</option>
                        <option value="2">Mesin Pengering (SnapClean)</option>
                        <option value="1">Mesin Cuci (SnapClean)</option>
                    </select>
                    <select class="form-control right-icon icon-dropdown" v-model="Jenis_mesin" id="form2" v-else
                            v-on:change="validateortoleransi">
                        <option value="" selected>Pilih Jenis Mesin</option>
                        <option value="2">Mesin Pengering (SnapClean)</option>
                        <option value="1">Mesin Cuci (SnapClean)</option>
                        <option value="3">Mesin Reguler</option>
                    </select>
                    <ErrorMessage class="error" label="Jenis Mesin" ref="errmsg_jenis_mesin"
                                  :validation="$v.Jenis_mesin"></ErrorMessage>
                </div>

                <div class="m-t-16 d-flex" v-if="Jenis_layanan==='2' && Jenis_mesin !== '3'">
                    <div class="flex-1">
                        <label for="" class="form-label">Kapasitas maksimal</label>
                        <div class="input-group mod">
                            <input type="tel" class="form-control load" placeholder="123.456" id="" value="0"
                                   v-model="load" @keyup="handlingload">
                            <div class="input-group-append">
                                <span class="input-group-text"
                                      v-if="selected_satuan_snap.text === 'Load' || selected_satuan_snap.text === 'Koin'">KG</span>
                                <span class="input-group-text" v-else>{{selected_satuan_snap.text}}</span>
                            </div>
                        </div>
                        <ErrorMessage class="error" label="Kapasitas Maksimal" ref="errmsg_kapasitas_maksimal"
                                      :validation="$v.load"></ErrorMessage>
                    </div>
                    <div class="flex-1 m-l-8">
                        <label for="" class="form-label">Toleransi</label>
                        <div class="input-group mod">
                            <input type="tel" class="form-control load" placeholder="123.456" id="" value="0"
                                   v-model="loadtoleransi" @keyup="handlingloadtoleransi">
                            <div class="input-group-append">
                                <span class="input-group-text"
                                      v-if="selected_satuan_snap.text === 'Load' || selected_satuan_snap.text === 'Koin'">KG</span>
                                <span class="input-group-text" v-else>{{selected_satuan_snap.text}}</span>
                            </div>
                        </div>
                        <ErrorMessage class="error" label="Toleransi" ref="errmsg_toleransi"
                                      :validation="$v.loadtoleransi"></ErrorMessage>
                    </div>
                </div>

                <div class="m-t-16" id="durasi_mesin_snap">
                    <div class="d-flex align-items-end">
                        <div class="form-group mod flex-1">
                            <InputMinPlus
                                    v-model="durasi_jam"
                                    :id="'jam_bekerja'"
                                    :minValue="0"
                                    :maxValue="23"
                                    :metric="'Jam'"
                                    :label="'Durasi mesin bekerja'"
                                    ref="durasijamref"
                            />
                            <ErrorMessage class="error" label="Durasi Mesin" ref="errmsg_durasi_jam"
                                          :validation="$v.durasi_jam"></ErrorMessage>
                        </div>
                        <div class="form-group mod flex-1 m-l-8 m-d-0">
                            <InputMinPlus
                                    v-model="durasi_menit"
                                    :id="'menit_bekerja'"
                                    :minValue="0"
                                    :maxValue="59"
                                    :metric="'Menit'"
                                    ref="durasimenitref"
                            />
                            <ErrorMessage class="error" label="Durasi Mesin" ref="errmsg_durasi_menit"
                                          :validation="$v.durasi_menit"></ErrorMessage>
                        </div>
                    </div>
                </div>

                <div class="m-t-16" id="Durasi_Pengerjaan">
                    <div class="d-flex align-items-end">
                        <div class="form-group mod flex-1">
                            <InputMinPlus
                                    v-model="durasi_hari_pengerjaan"
                                    :id="'hari_pengerjaan'"
                                    :minValue="0"
                                    :maxValue="31"
                                    :metric="'Hari'"
                                    :label="'Durasi Pengerjaan'"
                                    ref="durasiharipengerjaanref"
                            />
                            <ErrorMessage class="error" label="Durasi Pengerjaam" ref="errmsg_durasi_hari_pengerjaan"
                                          :validation="$v.durasi_hari_pengerjaan"></ErrorMessage>
                        </div>
                        <div class="form-group mod flex-1 m-l-8 m-d-0">
                            <InputMinPlus
                                    v-model="durasi_jam_pengerjaan"
                                    :id="'menit_pengerjaan'"
                                    :minValue="0"
                                    :maxValue="23"
                                    :metric="'Jam'"
                                    ref="durasijampengerjaanref"
                            />
                            <ErrorMessage class="error" label="Durasi Pengerjaan" ref="errmsg_durasi_jam_pengerjaan"
                                          :validation="$v.durasi_jam_pengerjaan"></ErrorMessage>
                        </div>
                    </div>
                </div>

                <div class="mar-top-12 mar-bot-12" :class="{'hide': Jenis_mesin === '3'}">
                    <label class="remove-margin require">Kategori Mesin</label>
                    <select class="js-example-basic-multiple form-control tagging" id="suggestsnap"
                            multiple="multiple">
                        <option v-if="suggestarraymesin !==0" v-for="mesin in suggestarraymesin">
                            {{ mesin.text }}
                        </option>
                    </select>
                </div>

                <div class="mar-top-12 mar-bot-12">
                    <label class="remove-margin">Kategori Layanan</label>
                    <select class="form-control tagging-layanan" id="suggestlayanan" multiple="true">
                        <option v-if="suggestarray !==0" v-for="option in suggestarray">
                            {{ option.text }}
                        </option>
                    </select>
                </div>
                <div>
                    <div class="separator-line m-d-20 m-t-20"></div>
                    <div class="m-d-20">
                        <SOToggleOnOff
                                @selected="onOffJamTertentu"
                                :isChecked="toggleJamTertentu"
                                checkTitle="Aktifkan Layanan Di Jam Tertentu"
                                checkId="min-order"
                                nama="min-order"
                        />
                    </div>
                    <div id="jamTertentu">
                        <div class="form-row">
                            <div class="form-group col-md-6 col-sm-6 col-6">

                                <div id="jam-crons" class="mb-2">
                                    <SOInputTime
                                            title="Jam Mulai "
                                            id="layanan_jam_mulai"
                                            placeholder="00:00"
                                            :value="layanan_jam_mulai"
                                            maxTime="layanan_jam_akhir"
                                            @get-time="(v) => layanan_jam_mulai = v"
                                    />
                                </div>
                            </div>
                            <div class="form-group col-md-6 col-sm-6 col-6">

                                <div id="jam-cronp" class="mb-2">
                                    <SOInputTime
                                            title="Jam Berakhir"
                                            id="layanan_jam_akhir"
                                            placeholder="00:00"
                                            :value="layanan_jam_akhir"
                                            minTime="layanan_jam_mulai"
                                            @get-time="(v) => layanan_jam_akhir = v"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

            <!-- BOTTOM -->
            <div class="w-limit p-x-20 p-t-24 p-d-20">
                <button type="button" class="btn smart-secondary" @click="checktagmesinadd"
                        id="anotherButton"><span class="spinner-border spinner-border-sm" role="status"
                                                 aria-hidden="true"
                                                 v-if="isClicked2 === true"></span><span id="textBtnother">Simpan & tambah lainnya</span>
                </button>
                <button type="button" class="btn smart-primary m-t-12" @click="checktagmesin"
                        id="btnNextCreateLayananSnap">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                          v-if="isClicked1 === true"></span><span id="textBtn2">Simpan</span></button>
            </div>
        </div>

    </div>
</template>

<script>
    import Select2 from 'v-select2-component';
    import InputMinPlus from "../../component-items/InputMinPlus";
    import InputRupiah from "../../component-items/InputRupiah";
    import SOToggleOnOff from "@/so-components/global/input/SOToggleOnOff.vue";
    import SOInputTime from "@/so-components/global/input/SOInputTime.vue";
    import ErrorMessage from "@/component-items/ErrorMessage";
    import {minValue, minLength, required} from "vuelidate/lib/validators";

    export default {
        name: "SnapCreate",
        props: ['setidoutletsetservice'],
        components: {
            Select2,
            InputMinPlus,
            InputRupiah,
            ErrorMessage,
            SOInputTime,
            SOToggleOnOff
        },
        data() {
            return {
                suggestarray: [],
                suggestarraymesin: [],
                selected_satuan: [],
                selected_satuan_snap: '',
                isClicked: false,
                isClicked1: false,
                isClicked2: false,
                snap_nama: '',
                snap_harga: {
                    raw: 0,
                    formatted: "",
                },
                durasi_jam: 0,
                durasi_menit: 0,
                durasi_hari_pengerjaan: 0,
                durasi_jam_pengerjaan: 0,
                Jenis_layanan: '',
                Jenis_mesin: '',
                loadtoleransi: '',
                load: '',
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
                layanan_jam_mulai: "00:00:00",
                layanan_jam_akhir: "23:00:00",
                toggleJamTertentu: false,

            }
        },
        validations: {
            snap_nama: {
                required,
                minLength: minLength(2),
            },
            Jenis_layanan: {
                required,
            },
            snap_harga: {
                raw: {
                    required,
                    minValue: minValue(1)
                },
            },
            selected_satuan_snap: {
                text: {
                    required,
                }
            },
            Jenis_mesin: {
                required
            },
            load: {
                required
            },
            loadtoleransi: {
                required
            },
            durasi_jam: {
                required
            },
            durasi_menit: {
                required
            },
            durasi_hari_pengerjaan: {
                required
            },
            durasi_jam_pengerjaan: {
                required
            }
        },
        watch: {
            durasi_jam_snap: function () {
                this.validateortoleransi();
            },
            durasi_menit: function () {
                this.validateortoleransi();
            },
            durasi_hari_pengerjaan: function () {
                this.validateortoleransi();
            },
            durasi_jam_pengerjaan: function () {
                this.validateortoleransi();
            },
            toggleJamTertentu: function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    if (newVal) {
                        $("#jamTertentu").show();
                    } else {
                        $("#jamTertentu").hide();
                    }
                }
            },
        },
        mounted() {
            this.idoutlet = this.$route.params.idoutlet
            this.tagging();
            this.tagginglayanan();
            this.suggest();
            this.suggestmesin();
            this.Selfserviceactive();
            this.getsatuanMetasnap()

            this.backButtonPressed(this.back)
            $("#jamTertentu").hide();

            this.smartTrackingView("add_layanan_selfservice", {"idoutlet": this.idoutlet});

        },
        methods: {
            onOffJamTertentu(val) {
                this.toggleJamTertentu = val;

            },
            tagging() {
                $(".tagging").select2({
                    placeholder: "Ketuk Untuk Menambah Tag", //placeholder
                    maximumSelectionLength: 1,
                    tags: false,

                });
            },

            tagginglayanan() {
                $(".tagging-layanan").select2({
                    placeholder: "Ketuk Untuk Menambah Tag", //placeholder
                    tags: true,

                });
            },


            back() {
                this.$emit('backtolist')
            },

            validateortoleransi() {
                if (this.Jenis_layanan === '1') {
                    this.cekValidate()
                } else {
                    if (this.Jenis_mesin == 3) {
                        $("#durasi_mesin_snap").hide();
                    } else {
                        $("#durasi_mesin_snap").show();
                    }
                    this.cekValidatetoleransi();
                }
            },

            Selfserviceactive() {
                var value = $("input[name=radioboxx]:checked").val();
                this.Jenis_layanan = '1';
                this.selected_satuan_snap = {
                    text: "Load",
                    value: 14
                }
                $("#radio1").prop("checked", true);
                $("#radio2").prop("checked", false);
                $('#Durasi_Pengerjaan').hide();
                $("#exampleFormControlSelect1").prop("disabled", true)
                this.cekValidate();
            },

            DropOffactive() {
                var value = $("input[name=radioboxx]:checked").val();
                this.Jenis_layanan = '2';
                this.selected_satuan_snap = {
                    text: "",
                    value: 0
                }
                $("#radio1").prop("checked", false);
                $("#radio2").prop("checked", true);
                $('#Durasi_Pengerjaan').show();
                $("#exampleFormControlSelect1").prop("disabled", false)
                this.cekValidatetoleransi();
            },

            inputnama() {
                var nums = this.snap_nama;
                var nama = nums.replace(/[^0-9A-Za-z-.,'& ]+/, '');
                this.snap_nama = nama
                if (this.Jenis_layanan === '1') {
                    this.cekValidate()
                } else {
                    this.cekValidatetoleransi();
                }
            },

            handlingload() {
                var handleevent = this.load;
                var handlenumber = handleevent.replace(/[^0-9,]+/, '');
                this.load = handlenumber;
                // this.cekValidatetoleransi()
                this.max100load();
            },

            max100load() {
                var inputkomisi = this.load;
                if (inputkomisi >= 100) {
                    this.load = 100
                }
                this.decimalload();
                this.cekValidatetoleransi()
            },

            decimalload() {
                $('.load').keyup(function (e) {
                    //Get the occurence of decimal operator
                    var match = $(this).val().match(/\./g);
                    if (match != null) {
                        // Allow: backspace, delete, tab, escape and enter
                        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
                            // Allow: Ctrl+A
                            (e.keyCode == 65 && e.ctrlKey === true) ||
                            // Allow: home, end, left, right
                            (e.keyCode >= 35 && e.keyCode <= 39)) {
                            // let it happen, don't do anything
                            return;
                        }  // Ensure that it is a number and stop the keypress
                        else if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105) && (e.keyCode == 190)) {
                            e.preventDefault();
                        }
                    } else {
                        // Allow: backspace, delete, tab, escape, enter and .
                        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
                            // Allow: Ctrl+A
                            (e.keyCode == 65 && e.ctrlKey === true) ||
                            // Allow: home, end, left, right
                            (e.keyCode >= 35 && e.keyCode <= 39)) {
                            // let it happen, don't do anything
                            return;
                        }
                        // Ensure that it is a number and stop the keypress
                        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                            e.preventDefault();
                        }
                    }
                });

                $('.load').keyup(function () {
                    var realValue = this.value
                    if ($(this).val().indexOf(',') != -1) {
                        if ($(this).val().split(",").length > 2) {
                            var stringData = this.value
                            var stringlenght = stringData.length
                            var setString = stringData.substring(0, stringlenght - 1)
                            this.value = setString
                        }
                        if ($(this).val().split(",")[1].length >= 2) {
                            if (isNaN(parseFloat(this.value))) {
                                return
                            }
                            var value = realValue.replace(",", ".")
                            var fakeValue = parseFloat(value).toFixed(2);
                            var fakeValueStr = fakeValue.toString()
                            this.value = fakeValueStr.replace(".", ",")
                        }
                    }
                })
            },

            handlingloadtoleransi() {
                var handleevent = this.loadtoleransi;
                var handlenumber = handleevent.replace(/[^0-9,]+/, '');
                this.loadtoleransi = handlenumber;
                this.max100toleransi();
            },

            max100toleransi() {
                var inputkomisi = this.loadtoleransi;
                if (inputkomisi >= 100) {
                    this.loadtoleransi = 100
                }
                this.decimalload();
                this.cekValidatetoleransi();
            },

            inputnumber() {
                var handleevent = this.snap_harga;
                var handlenumber = handleevent.replace(/[^0-9]+/, '');
                this.snap_harga = handlenumber;
                this.formatrupiahdeposit();
                if (this.Jenis_layanan === '1') {
                    this.cekValidate()
                } else {
                    this.cekValidatetoleransi();
                }
            },

            formatrupiahdeposit() {
                var rupiah = this.snap_harga;
                var formattedrupiah = this.newrupiahdeposit(rupiah);
                this.snap_harga = formattedrupiah
            },

            newrupiahdeposit(angka, prefix) {
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^,\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            cekValidate() {
                return
                var NamaLayanan = this.snap_nama;
                var HargaLayanan = this.snap_harga;
                var DurasijamMesin = this.durasi_jam;
                var DurasiMenitMesin = this.durasi_menit;
                // var SelectLayanan = this.selected_satuan_snap;
                var tipeLayanan = this.Jenis_layanan;
                var tipeMesin = this.Jenis_mesin;
                var lenPass = NamaLayanan.length;
                if (lenPass >= 2 && HargaLayanan.length >= 2 && tipeLayanan !== '' && tipeMesin !== '') {
                    $('#btnNextCreateLayananSnap').prop('disabled', false);
                    $('#anotherButton').prop('disabled', false);
                    if (DurasijamMesin === '0' && DurasiMenitMesin === '0') {
                        $('#btnNextCreateLayananSnap').prop('disabled', true);
                        $('#anotherButton').prop('disabled', true)
                    }
                } else {
                    $('#btnNextCreateLayananSnap').prop('disabled', true);
                    $('#anotherButton').prop('disabled', true);
                }
            },

            cekValidatetoleransi() {
                return
                var NamaLayanan = this.snap_nama;
                var HargaLayanan = this.snap_harga.formatted;
                var DurasijamMesin = this.durasi_jam;
                var DurasiMenitMesin = this.durasi_menit;
                var DurasihariMesin = this.durasi_hari_pengerjaan;
                var DurasiJamPMesin = this.durasi_jam_pengerjaan;
                var tipeLayanan = this.Jenis_layanan;
                var tipeMesin = this.Jenis_mesin;
                var selectLayanan = this.selected_satuan_snap.value;
                var load = this.load;
                var loadtoleransi = this.loadtoleransi;
                var lenPass = NamaLayanan.length;
                if (lenPass >= 2 && HargaLayanan.length >= 2 && tipeLayanan !== '' && tipeMesin !== '' && load > '0' && loadtoleransi > '0' && selectLayanan > 0) {
                    $('#btnNextCreateLayananSnap').prop('disabled', false);
                    $('#anotherButton').prop('disabled', false);
                    if (DurasijamMesin === '0' && DurasiMenitMesin === '0') {
                        $('#btnNextCreateLayananSnap').prop('disabled', true);
                        $('#anotherButton').prop('disabled', true)
                    }

                    if (DurasihariMesin === '0' && DurasiJamPMesin === '0') {
                        $('#btnNextCreateLayananSnap').prop('disabled', true);
                        $('#anotherButton').prop('disabled', true)
                    }
                } else {
                    $('#btnNextCreateLayananSnap').prop('disabled', true);
                    $('#anotherButton').prop('disabled', true);
                }
            },

            checktagmesinadd() {
                this.isClicked2 = true;
                $('#textBtnother').hide();
                $('#anotherButton').prop('disabled', true);
                var suggesnapval = $("#suggestsnap").select2('data');
                var lenghtArray = suggesnapval.length;

                if (this.Jenis_mesin === "3") {
                    this.postLayananaddsnap();
                    this.isClicked2 = false;
                    $('#textBtnother').show();
                    $('#anotherButton').prop('disabled', false);
                    return
                }
                if (lenghtArray > 0) {
                    this.postLayananaddsnap()
                    this.isClicked2 = false;
                    $('#textBtnother').show();
                    $('#anotherButton').prop('disabled', false);
                } else {
                    this.isClicked2 = false;
                    $('#textBtnother').show();
                    $('#anotherButton').prop('disabled', false);
                    this.$toast.error("Tag Mesin Tidak Boleh Kosong")
                }
            },

            checktagmesin() {
                this.isClicked2 = true;
                $('#textBtnother').hide();
                $('#anotherButton').prop('disabled', true);
                var suggesnapval = $("#suggestsnap").select2('data');
                var lenghtArray = suggesnapval.length;

                if (this.Jenis_mesin === "3") {
                    this.postLayanansnap();
                    this.isClicked2 = false;
                    $('#textBtnother').show();
                    $('#anotherButton').prop('disabled', false);
                    return
                }
                if (lenghtArray > 0) {
                    this.postLayanansnap();
                    this.isClicked2 = false;
                    $('#textBtnother').show();
                    $('#anotherButton').prop('disabled', false);
                } else {
                    this.isClicked2 = false;
                    $('#textBtnother').show();
                    $('#anotherButton').prop('disabled', false);
                    this.$toast.error("Kategori Mesin Tidak Boleh Kosong")
                }
            },

            async getsatuanMetasnap() {
                this.isClicked = true
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const satuan = new FormData;
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/satuan_meta', this.requestHeaders);
                    if (response.status === 200) {
                        var layanan = response.data.data;
                        for (var i = 0; i < layanan.length; i++) {
                            this.selected_satuan.push({
                                value: layanan[i].iddata_satuan,
                                text: layanan[i].nama
                            })
                        }
                        this.isClicked = false;
                        $('#loadingPage').removeClass('overlayLoading');
                    } else {
                        this.$toast.error(response.data, msg)
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                }
            },

            errorValidation(jenis_layanan) {
                if (jenis_layanan == 1) {
                    this.$v.snap_nama.$touch()
                    this.$v.Jenis_layanan.$touch()
                    this.$v.snap_harga.raw.$touch()
                    this.$v.selected_satuan_snap.text.$touch()
                    this.$v.Jenis_mesin.$touch()
                    this.$v.durasi_jam.$touch()
                    this.$v.durasi_menit.$touch()
                    return this.$v.snap_nama.$invalid ||
                        this.$v.Jenis_layanan.$invalid ||
                        this.$v.snap_harga.raw.$invalid ||
                        this.$v.selected_satuan_snap.text.$invalid ||
                        this.$v.Jenis_mesin.$invalid ||
                        this.$v.durasi_jam.$invalid ||
                        this.$v.durasi_menit.$invalid
                } else {
                    if (this.Jenis_mesin === '3') {
                        this.$v.snap_nama.$touch()
                        this.$v.Jenis_layanan.$touch()
                        this.$v.snap_harga.raw.$touch()
                        this.$v.selected_satuan_snap.text.$touch()
                        this.$v.Jenis_mesin.$touch()
                        this.$v.durasi_jam.$touch()
                        this.$v.durasi_menit.$touch()
                        this.$v.durasi_hari_pengerjaan.$touch()
                        this.$v.durasi_jam_pengerjaan.$touch()
                        return this.$v.snap_nama.$invalid ||
                            this.$v.Jenis_layanan.$invalid ||
                            this.$v.snap_harga.raw.$invalid ||
                            this.$v.selected_satuan_snap.text.$invalid ||
                            this.$v.Jenis_mesin.$invalid ||
                            this.$v.durasi_hari_pengerjaan.$invalid ||
                            this.$v.durasi_jam_pengerjaan.$invalid ||
                            ((this.Jenis_mesin != 3) ? this.$v.durasi_jam.$invalid || this.$v.durasi_menit.$invalid : false)
                    } else {
                        this.$v.snap_nama.$touch()
                        this.$v.Jenis_layanan.$touch()
                        this.$v.snap_harga.raw.$touch()
                        this.$v.selected_satuan_snap.text.$touch()
                        this.$v.Jenis_mesin.$touch()
                        this.$v.load.$touch()
                        this.$v.loadtoleransi.$touch()
                        this.$v.durasi_jam.$touch()
                        this.$v.durasi_menit.$touch()
                        this.$v.durasi_hari_pengerjaan.$touch()
                        this.$v.durasi_jam_pengerjaan.$touch()
                        return this.$v.snap_nama.$invalid ||
                            this.$v.Jenis_layanan.$invalid ||
                            this.$v.snap_harga.raw.$invalid ||
                            this.$v.selected_satuan_snap.text.$invalid ||
                            this.$v.Jenis_mesin.$invalid ||
                            this.$v.load.$invalid ||
                            this.$v.loadtoleransi.$invalid ||
                            this.$v.durasi_hari_pengerjaan.$invalid ||
                            this.$v.durasi_jam_pengerjaan.$invalid ||
                            ((this.Jenis_mesin != 3) ? this.$v.durasi_jam.$invalid || this.$v.durasi_menit.$invalid : false)
                    }
                }
            },

            async postLayananaddsnap() {
                if (this.errorValidation(this.Jenis_layanan)) {
                    this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
                    return
                }

                if (this.Jenis_mesin != 3) {
                    if (parseInt(this.durasi_jam) === 0 && parseInt(this.durasi_menit) === 0) {
                        this.$toast.error("Durasi Mesin Harus Diisi")
                        return
                    }
                }

                if (this.Jenis_layanan == 2) {
                    if (parseInt(this.durasi_hari_pengerjaan) === 0 && parseInt(this.durasi_jam_pengerjaan) === 0) {
                        this.$toast.error("Durasi Pengerjaan Harus Diisi")
                        return
                    }
                }

                this.isClicked2 = true;
                $('#textBtnother').hide();
                $('#anotherButton').prop('disabled', true);
                var dataTags = $("#suggestlayanan").select2('data');
                var dataTagssnap = $("#suggestsnap").select2('data');
                var jammesinadd = this.durasi_jam;
                var menitmesinadd = this.durasi_menit;
                var hariesinadd = this.durasi_hari_pengerjaan;
                var jamPmesinadd = this.durasi_jam_pengerjaan;
                var hargalayanansnapadd = this.snap_harga.formatted.toString();
                var satuanselect = this.selected_satuan_snap.value;

                try {
                    const snapother = new FormData;
                    snapother.append('idoutlet', this.setidoutletsetservice);
                    snapother.append('nama_layanan', this.snap_nama);
                    snapother.append('harga', hargalayanansnapadd);
                    snapother.append('durasi_jam', jammesinadd);
                    snapother.append('durasi_menit', menitmesinadd);
                    snapother.append('durasi_hari_kerja', hariesinadd);
                    snapother.append('durasi_jam_kerja', jamPmesinadd);
                    snapother.append('jenis_layanan', this.Jenis_layanan);
                    snapother.append('jenis_mesin', this.Jenis_mesin);
                    snapother.append('load', this.load);
                    snapother.append('load_toleransi', this.loadtoleransi);
                    snapother.append('komisi_helper', '0');
                    snapother.append('status_komisi_helper', '0');
                    snapother.append('status_wajib_lunas', '0');
                    snapother.append('idsatuan', satuanselect);
                    if(this.toggleJamTertentu){
                        snapother.append('jam_tertentu_aktif', 1);
                        if(this.layanan_jam_mulai>this.layanan_jam_akhir){
                            this.$toast.error("Jam mulai tidak boleh melebihi jam akhir")
                            return
                        }


                    }else{
                        snapother.append('jam_tertentu_aktif', 0);

                    }
                    snapother.append('jam_tertentu_awal', this.layanan_jam_mulai);
                    snapother.append('jam_tertentu_akhir', this.layanan_jam_akhir);

                    for (var i = 0; i < dataTags.length; i++) {
                        snapother.append('kategori_layanan[]', dataTags[i].text)
                    }
                    for (var i = 0; i < dataTagssnap.length; i++) {
                        snapother.append('kategori_mesin[]', dataTagssnap[i].text)
                    }
                    const response = await this.$axios.post(this.$baseurl + '/masterData/snap/create_layanan_snap',
                        snapother, this.requestHeaders)
                    if (response.data.status === true) {
                        this.isClicked2 = false;
                        $('#textBtnother').show();
                        $('#anotherButton').prop('disabled', false);
                        this.snap_nama = '';
                        this.snap_harga = {
                            raw: 0,
                            formatted: "",
                        };
                        this.$refs.inputrupiah.getValRupiah("0")
                        this.durasi_jam = 0;
                        this.durasi_menit = 0;
                        this.durasi_jam_pengerjaan = 0;
                        this.durasi_hari_pengerjaan = 0;
                        this.load = '';
                        this.loadtoleransi = '';
                        this.Selfserviceactive();
                        this.Jenis_mesin = 0;
                        $('#suggestlayanan').val('').trigger('change');
                        $('#suggestsnap').val('').trigger('change');
                        $('#anotherButton').prop('disabled', false);
                        $('#btnNextCreateLayananSnap').prop('disabled', false);

                        this.$refs.durasijamref.setValue(0)
                        this.$refs.durasimenitref.setValue(0)
                        this.$refs.durasiharipengerjaanref.setValue(0)
                        this.$refs.durasijampengerjaanref.setValue(0)

                        this.$toast.success(response.data.msg)

                        this.$refs.errmsg_nama_layanan.resetValidation()
                        this.$refs.errmsg_jenis_layanan.resetValidation()
                        this.$refs.errmsg_harga.resetValidation()

                        this.$refs.errmsg_durasi_jam.resetValidation()
                        this.$refs.errmsg_durasi_menit.resetValidation()

                        // jenis = 2
                        if (this.Jenis_layanan == '2') {
                            this.$refs.errmsg_satuan.resetValidation()
                            this.$refs.errmsg_toleransi.resetValidation()
                            this.$refs.errmsg_jenis_mesin.resetValidation()
                            this.$refs.errmsg_kapasitas_maksimal.resetValidation()
                            this.$refs.errmsg_durasi_hari_pengerjaan.resetValidation()
                            this.$refs.errmsg_durasi_jam_pengerjaan.resetValidation()
                        }
                    } else {
                        this.isClicked2 = false
                        $('#textBtnother').show()
                        $('#anotherButton').prop('disabled', false);
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        this.$toast.error(response.data.msg)
                    }

                } catch (e) {
                    this.$catch_error_response(e)
                    this.isClicked2 = false
                    $('#textBtnother').show()
                    $('#anotherButton').prop('disabled', false);
                }

                this.smartTrackingClick("simpan_layanan_selfservice_lainnya", {"idoutlet": this.idoutlet});

            },
            async postLayanansnap() {
                if (this.errorValidation(this.Jenis_layanan)) {
                    this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
                    return
                }

                if (this.Jenis_mesin != 3) {
                    if (parseInt(this.durasi_jam) === 0 && parseInt(this.durasi_menit) === 0) {
                        this.$toast.error("Durasi Mesin Harus Diisi")
                        return
                    }
                }

                if (this.Jenis_layanan == 2) {
                    if (parseInt(this.durasi_hari_pengerjaan) === 0 && parseInt(this.durasi_jam_pengerjaan) === 0) {
                        this.$toast.error("Durasi Pengerjaan Harus Diisi")
                        return
                    }
                }

                this.isClicked1 = true
                $('#textBtn2').hide()
                $('#btnNextCreateLayananSnap').prop('disabled', true);
                var dataTags = $("#suggestlayanan").select2('data');
                var dataTagssnap = $("#suggestsnap").select2('data');
                var jammesin = this.durasi_jam
                var menitmesin = this.durasi_menit
                var hariesin = this.durasi_hari_pengerjaan
                var jamPmesin = this.durasi_jam_pengerjaan
                var hargalayanansnap = this.snap_harga.formatted.toString();
                var satuanselect = this.selected_satuan_snap.value;
                try {
                    const snap = new FormData;
                    snap.append('idoutlet', this.setidoutletsetservice);
                    snap.append('nama_layanan', this.snap_nama);
                    snap.append('harga', hargalayanansnap);
                    snap.append('durasi_jam', jammesin);
                    snap.append('durasi_menit', menitmesin);
                    snap.append('durasi_hari_kerja', hariesin);
                    snap.append('durasi_jam_kerja', jamPmesin);
                    snap.append('jenis_layanan', this.Jenis_layanan);
                    snap.append('jenis_mesin', this.Jenis_mesin);
                    snap.append('load', this.load);
                    snap.append('load_toleransi', this.loadtoleransi);
                    snap.append('komisi_helper', '0');
                    snap.append('status_komisi_helper', '0');
                    snap.append('status_wajib_lunas', '0');
                    snap.append('idsatuan', satuanselect)
                    if(this.toggleJamTertentu){
                        snap.append('jam_tertentu_aktif', 1);
                        if(this.layanan_jam_mulai>this.layanan_jam_akhir){
                            this.$toast.error("Jam mulai tidak boleh melebihi jam akhir")
                            return
                        }

                    }else{
                        snap.append('jam_tertentu_aktif', 0);

                    }
                    snap.append('jam_tertentu_awal', this.layanan_jam_mulai);
                    snap.append('jam_tertentu_akhir', this.layanan_jam_akhir);

                    for (var i = 0; i < dataTags.length; i++) {
                        snap.append('kategori_layanan[]', dataTags[i].text)
                    }
                    for (var i = 0; i < dataTagssnap.length; i++) {
                        snap.append('kategori_mesin[]', dataTagssnap[i].text)
                    }
                    const response = await this.$axios.post(this.$baseurl + '/masterData/snap/create_layanan_snap',
                        snap, this.requestHeaders);
                    if (response.data.status === true) {
                        this.snap_nama = '';
                        this.snap_harga = {
                            raw: 0,
                            formatted: 0,
                        };
                        this.durasi_jam = 0;
                        this.durasi_menit = 0;

                        this.$refs.durasijamref.setValue(0)
                        this.$refs.durasimenitref.setValue(0)
                        this.$refs.durasiharipengerjaanref.setValue(0)
                        this.$refs.durasijampengerjaanref.setValue(0)

                        // $('#input-3').val(0);
                        // $('#input-4').val(0);
                        $('#suggestlayanan').val('').trigger('change');
                        $('#suggestsnap').val('').trigger('change');
                        this.$toast.success(response.data.msg)
                        this.isClicked1 = false;
                        $('#textBtn2').show();
                        $('#btnNextCreateLayananSnap').prop('disabled', false);
                        this.back()
                    } else {
                        this.isClicked1 = false
                        $('#textBtn2').show()
                        $('#btnNextCreateLayananSnap').prop('disabled', false);
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        this.$toast.error(response.data.msg)
                    }

                } catch (e) {
                    this.$catch_error_response(e)
                    this.isClicked1 = false;
                    $('#textBtn2').show();
                    $('#btnNextCreateLayananSnap').prop('disabled', false);
                }
                this.smartTrackingClick("simpan_layanan_selfservice", {"idoutlet": this.idoutlet});

            },
            async suggest() {
                try {
                    const response = await this.$axios.get(this.$baseurl +
                        '/masterData/meta/list_suggest_tags_layanan', this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            var suggest = response.data.data
                            for (var i = 0; i < suggest.length; i++) {
                                this.suggestarray.push({
                                    idtags: suggest[i].idtags,
                                    text: suggest[i].nama
                                })
                            }
                        }
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingPage').hide();
                    $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async suggestmesin() {
                try {
                    const response = await this.$axios.get(this.$baseurl +
                        '/masterData/meta/list_snap_kategori_mesin?idoutlet=' + this.setidoutletsetservice, this
                        .requestHeaders);
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            var suggestmesin = response.data.data
                            for (var i = 0; i < suggestmesin.length; i++) {
                                this.suggestarraymesin.push({
                                    idtags: suggestmesin[i].idtags,
                                    text: suggestmesin[i].nama
                                })
                            }
                        }
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingPage').hide();
                    $('#loadingPage').removeClass('overlayLoading');
                }
            }
        }
    }
</script>

<style scoped>
    .set-jenissnap {
        background: #FFFFFF;
        border: 1px solid #C8D0DD;;
        box-sizing: border-box;
        border-radius: 3px;
        display: flex;
        flex-direction: row;
        padding: 8px 10px;
    }

    .actvive-border {
        background: rgba(32, 108, 255, 0.1);
        border: 1px solid rgba(32, 108, 255, 0.35);
    }

    .set-input {
        border: 1px solid #C8D0DD;
        margin: 0px 1px;
        text-align: center;
        padding: 5px;
        margin-left: 0px;
        margin-right: 0px;
    }

    .width-input {
        max-width: 50%;
    }

    .set-button {
        background: #FFFFFF;
        border: 1px solid #C8D0DD;
        box-sizing: border-box;
        border-radius: 0px 3px 3px 0px;
        width: 36px;
        padding: 5px;
        color: #206CFF;
    }
</style>


<!--countplus(dataId, type) {-->
<!--// var valueData = $('#' + dataId).val()-->
<!--// var valueInt = parseInt(valueData)-->
<!--// var math = valueInt + 1-->
<!--// $('#' + dataId).val(math)-->
<!--// $('#' + dataId + 'Text').val(math + ' ' + type)-->
<!--if (type === "Jam") {-->
<!--var tempCountplus = this.durasi_Jam_snap + 1-->
<!--if (tempCountplus <= 24) {-->
<!--this.durasi_Jam_snap++;-->
<!--this.durasi_jam_snap_text = this.durasi_Jam_snap + ' ' + type-->
<!--}-->
<!--} else {-->
<!--var tempcountplus1 = this.durasi_menit + 1-->
<!--if (tempcountplus1 <= 60) {-->
<!--this.durasi_menit++;-->
<!--this.durasi_menit_text = this.durasi_menit + ' ' + type-->
<!--}-->
<!--}-->
<!--this.cekValidate()-->
<!--},-->
<!--countminus(dataId, type) {-->
<!--if (type === "Jam") {-->
<!--var tempCountminus = this.durasi_Jam_snap - 1-->
<!--if (tempCountminus >= 0) {-->
<!--this.durasi_Jam_snap&#45;&#45;;-->
<!--this.durasi_jam_snap_text = this.durasi_Jam_snap + ' ' + type-->
<!--}-->
<!--} else {-->
<!--var tempCountminus1 = this.durasi_menit - 1-->
<!--if (tempCountminus1 >= 0) {-->
<!--this.durasi_menit&#45;&#45;;-->
<!--this.durasi_menit_text = this.durasi_menit + ' ' + type-->
<!--}-->
<!--}-->
<!--this.cekValidate()-->
<!--},-->